<p-select
  [options]="formField.options"
  [formControl]="ctrl"
  optionLabel="label"
  optionValue="value"
  [filter]="true"
  filterBy="value"
  [showClear]="true"
  [placeholder]="formField.placeholder"
/>
